/* eslint-disable */
import $ from "jquery";

//import Articles from "./components/Articles.vue";
//import Posts from "./components/Posts.vue";
//import Projects from "./components/Projects.vue";
// import lozad from "lozad";

// usage: log('inside coolFunc',this,arguments);
// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function() {
  log.history = log.history || []; // store logs to an array for reference
  log.history.push(arguments);
  if (this.console) window.console.log(Array.prototype.slice.call(arguments));
};

window.jQuery = window.$ = $;

//const observer = lozad();
//observer.observe();

const jQuery = $;

// Global page scripts
$(function() {
  //Toggle bulma mobile nav classes on click
  $(".navbar-burger").on('click', function() {
    $(".navbar-burger").toggleClass("is-active");
    $(".navbar-menu").toggleClass("is-active");
  });

  // Making sure current menu item is the first one on root path
  // (hackish fix because of missing query vars on home page -issue)
  if (this.location.pathname === '/') {
    const firstMenuElement = $('#main-navbar').find('a.menu-item').first();
    firstMenuElement.addClass('current-menu-item');
  }
});
